// src/utils/sendContactEmail.js
import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_CONTACT_SERVICE_ID?.trim() || "";
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID?.trim() || "";
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY?.trim() || "";

// const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID?.trim() || "";
// const CONTACT_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID?.trim() || "";
// const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY?.trim() || "";

// ─── HTML Builder ─────────────────────────────────────────────────────────────

function buildContactHTML({ name, email, subject, message, logoURL }) {

  const logo = logoURL && logoURL.startsWith("http")
    ? `<img src="${logoURL}" alt="DawaCare"
               style="max-height:60px;max-width:200px;object-fit:contain;display:block;margin:0 auto;" />`
    : `<span style="font-size:24px;font-weight:800;color:#ffffff;
                        letter-spacing:1.5px;font-family:Arial,sans-serif;">DawaCare</span>`;

  const now = new Date();
  const timestamp = now.toLocaleString("en-PK", { dateStyle: "full", timeStyle: "short" });

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width,initial-scale=1.0" />
  <title>New Message – DawaCare</title>
  <style>
    @media only screen and (max-width:520px) {
      .outer   { padding: 0 !important; }
      .card    { border-radius: 0 !important; }
      .body-pad { padding: 28px 20px !important; }
      .btn-link { padding: 13px 28px !important; font-size:14px !important; }
    }
  </style>
</head>
<body style="margin:0;padding:0;background:#efefef;font-family:Arial,Helvetica,sans-serif;">

  <table class="outer" width="100%" cellpadding="0" cellspacing="0"
         style="padding:40px 16px;">
    <tr>
      <td align="center">
        <table class="card" width="100%" cellpadding="0" cellspacing="0"
               style="max-width:600px;background:#ffffff;border-radius:20px;
                      overflow:hidden;box-shadow:0 6px 32px rgba(0,0,0,0.10);">

          <!-- ══ HEADER ══ -->
          <tr>
            <td style="background:#d2222d;padding:36px 40px 28px;text-align:center;">

              <!-- Logo -->
              ${logo}

              <!-- Yellow title under logo -->
              <p style="margin:20px 0 0;
                         font-size:22px;
                         font-weight:700;
                         color:#FFD700;
                         font-family:Arial,sans-serif;
                         line-height:1.35;
                         letter-spacing:0.3px;">
                🔔 Message received from ${name}
              </p>

              <!-- Timestamp in white -->
              <p style="margin:8px 0 0;
                         font-size:13px;
                         color:rgba(255,255,255,0.75);
                         font-family:Arial,sans-serif;">
                ${timestamp}
              </p>

            </td>
          </tr>

          <!-- ══ BODY ══ -->
          <tr>
            <td class="body-pad" style="padding:40px 44px;">

              <!-- ── From ── -->
              <table width="100%" cellpadding="0" cellspacing="0"
                     style="margin-bottom:14px;">
                <tr>
                  <td style="font-size:11px;font-weight:700;color:#aaa;
                              text-transform:uppercase;letter-spacing:1px;
                              padding-bottom:5px;font-family:Arial,sans-serif;">
                    From
                  </td>
                </tr>
                <tr>
                  <td style="font-size:17px;font-weight:700;color:#1a1a1a;
                              font-family:Arial,sans-serif;">
                    ${name}
                  </td>
                </tr>
              </table>

              <!-- Divider -->
              <hr style="border:none;border-top:1px solid #ebebeb;margin:0 0 14px;" />

              <!-- ── Email ── -->
              <table width="100%" cellpadding="0" cellspacing="0"
                     style="margin-bottom:14px;">
                <tr>
                  <td style="font-size:11px;font-weight:700;color:#aaa;
                              text-transform:uppercase;letter-spacing:1px;
                              padding-bottom:5px;font-family:Arial,sans-serif;">
                    Email Address
                  </td>
                </tr>
                <tr>
                  <td style="font-size:15px;color:#d2222d;font-family:Arial,sans-serif;">
                    <a href="mailto:${email}"
                       style="color:#d2222d;text-decoration:none;font-weight:600;">
                      ${email}
                    </a>
                  </td>
                </tr>
              </table>

              <!-- Divider -->
              <hr style="border:none;border-top:1px solid #ebebeb;margin:0 0 14px;" />

              <!-- ── Subject ── -->
              <table width="100%" cellpadding="0" cellspacing="0"
                     style="margin-bottom:32px;">
                <tr>
                  <td style="font-size:11px;font-weight:700;color:#aaa;
                              text-transform:uppercase;letter-spacing:1px;
                              padding-bottom:5px;font-family:Arial,sans-serif;">
                    Subject
                  </td>
                </tr>
                <tr>
                  <td style="font-size:16px;font-weight:600;color:#1a1a1a;
                              font-family:Arial,sans-serif;">
                    ${subject}
                  </td>
                </tr>
              </table>

              <!-- ── Message Box ── -->
              <table width="100%" cellpadding="0" cellspacing="0"
                     style="margin-bottom:36px;">
                <tr>
                  <td style="font-size:11px;font-weight:700;color:#aaa;
                              text-transform:uppercase;letter-spacing:1px;
                              padding-bottom:10px;font-family:Arial,sans-serif;">
                    Message
                  </td>
                </tr>
                <tr>
                  <td style="background:#fafafa;border-radius:12px;
                              padding:22px 24px;
                              font-size:15px;color:#333;line-height:1.75;
                              font-family:Arial,sans-serif;
                              white-space:pre-wrap;
                              border:1px solid #ebebeb;">
${message}
                  </td>
                </tr>
              </table>

              <!-- ── Reply Button ── -->
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="center">
                    <a class="btn-link"
                       href="mailto:${email}?subject=Re%3A%20${encodeURIComponent(subject)}"
                       style="display:inline-block;
                              background:#d2222d;
                              color:#ffffff;
                              text-decoration:none;
                              font-size:15px;
                              font-weight:700;
                              padding:14px 44px;
                              border-radius:50px;
                              font-family:Arial,sans-serif;
                              letter-spacing:0.4px;">
                      📩 Reply to ${name}
                    </a>
                  </td>
                </tr>
              </table>

            </td>
          </tr>

          <!-- ══ FOOTER ══ -->
          <tr>
            <td style="background:#f8f8f8;
                        border-top:1px solid #ebebeb;
                        padding:22px 40px;
                        text-align:center;
                        font-size:12px;
                        color:#bbb;
                        font-family:Arial,sans-serif;
                        line-height:1.7;">
              This message was submitted through the DawaCare Contact Us form.<br />
              &copy; dawaacare.com &nbsp;&middot;&nbsp; All rights reserved
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>

</body>
</html>`;
}

// ─── Main Export ──────────────────────────────────────────────────────────────

/**
 * Sends a styled Contact Us notification email via EmailJS.
 *
 * EmailJS template variables:
 *   {{title}}    → subject line
 *   {{name}}     → From Name field
 *   {{{message}}} → full HTML body  (triple braces in EmailJS template body!)
 *   {{email}}    → Reply-To field
 *
 * @param {{ name: string, email: string, subject: string, message: string }} formData
 * @param {string} [logoURL]  Hosted footer logo URL from ContentContext
 */
export async function sendContactEmail({ name, email, subject, message }, logoURL = "") {
  if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
    throw new Error("EmailJS contact configuration is missing. Check your .env file.");
  }

  const html = buildContactHTML({ name, email, subject, message, logoURL });

  await emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    {
      title: 'Inquiry through Contact form',  // → {{title}}   in EmailJS (used as email Subject)
      name,              // → {{name}}    in EmailJS (From Name)
      message: html,     // → {{{message}}} in EmailJS body — triple braces for raw HTML!
      email: 'contact@dawaacare.com', // → {{email}}   in EmailJS (To Email)
      reply_to: email,   // → {{reply_to}} in EmailJS (Reply-To)
    },
    PUBLIC_KEY
  );
}
